import type { ScreenState } from '@hana/ui';

// Quyền vùng HANA Kit: chỉ ghế có cờ ADMIN (QĐ anh David 01/Nov 09:49 · canvas MAPPS.adm, board Mint-Admin `hasPerm`).
// TODO(A): ghế thật đến từ phiên Office 365 + bảng ghế khi luồng A có; tạm theo dữ liệu mẫu của canvas (seatRow ADMIN · DAVID).

/** Mã đăng nhập đang giữ cờ ADMIN (canvas: chip "ADMIN · DAVID", Settings › seatRow 'ADMIN'). */
export const KIT_ADMINS: readonly string[] = ['DAVID'];

/** Mã đăng nhập từ tài khoản Office 365: phần trước @, chữ hoa (david@… → DAVID). */
export const viewerCode = (username: string | undefined | null): string => (username ?? '').split('@')[0]!.trim().toUpperCase();

export const isKitAdmin = (code: string | undefined | null): boolean => !!code && KIT_ADMINS.includes(code.trim().toUpperCase());

const STATES: readonly ScreenState[] = ['ready', 'loading', 'empty', 'error', 'noperm'];

export interface KitAccess {
  /** mã người đang xem (xem thử bằng `?viewer=`) */
  viewer: string | null;
  admin: boolean;
  /** trạng thái màn: ép bằng `?state=` như prop của board; không phải ADMIN → `noperm` */
  state: ScreenState;
}

/** `search` = location.search; `shellAdmin` = cờ ADMIN của người đăng nhập (từ khung Hub). */
export function kitAccess(search: string, shellAdmin: boolean): KitAccess {
  const p = new URLSearchParams(search);
  const v = p.get('viewer');
  const admin = v ? isKitAdmin(v) : shellAdmin;
  const st = p.get('state') as ScreenState | null;
  const forced = st && STATES.includes(st) ? st : null;
  return { viewer: v ? v.toUpperCase() : null, admin, state: !admin ? 'noperm' : forced ?? 'ready' };
}
